module.exports = __webpack_public_path__ + "ed83f4ca3466eba334c3992409e1b9f0.woff";